import React from 'react'
import { Helmet } from 'react-helmet'
import App from '../components/App'
import 'bootstrap/dist/css/bootstrap.min.css'
import '../style/main.scss'
import favicon from '../images/favicon.svg'

export default () => (
  <>
    <Helmet>
      <meta charSet="utf-8" />
      <title>Kilimanjaro Climb 2021</title>
      <html lang="en" />
      <meta
        name="description"
        content="A fundraiser supporting the American Cancer Society"
      />
      <link rel="icon" type="image/png" href={favicon} sizes="16x16" />
    </Helmet>
    <App />
  </>
)
